// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuidedTourComponent } from './guided-tour.component';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@med/app/shared/modules/button/button.module';
import { GuidedTourService } from '@med/app/home/demo/guided-tour/services/guided-tour.service';
import { guidedTourReducer, STATE_NAME } from '@med/app/home/demo/guided-tour/store/guided-tour.reducers';
import { StepPositionService } from '@med/app/home/demo/guided-tour/services/step-position.service';
import { ElementPosition } from '@med/app/home/demo/guided-tour/services/element-position.service';
import { ElementDimensionObserverAggregateService } from '@med/app/home/demo/guided-tour/services/element-dimension-observer-aggregate.service';
import { PortalComponent } from './components/portal/portal.component';
import { GuidedTourDialogComponent } from '@med/app/home/demo/guided-tour/components/guided-tour-dialog/guided-tour-dialog.component';
import { ExposedElementComponent } from '@med/app/home/demo/guided-tour/components/exposed-element/exposed-element.component';
import { PortalDimensionsService } from '@med/app/home/demo/guided-tour/services/portal-dimensions.service';
import { GuidedTourSkeletonComponent } from './components/guided-tour-skeleton/guided-tour-skeleton.component';
import { SpinnerModule } from '@med/app/shared/modules/spinner/spinner.module';

@NgModule({
  declarations: [
    GuidedTourDialogComponent,
    GuidedTourComponent,
    PortalComponent,
    ExposedElementComponent,
    GuidedTourSkeletonComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, guidedTourReducer),
    TranslateModule,
    ButtonModule,
    SpinnerModule,
  ],
  exports: [GuidedTourComponent],
  providers: [
    GuidedTourService,
    StepPositionService,
    ElementPosition,
    ElementDimensionObserverAggregateService,
    PortalDimensionsService,
  ],
})
export class GuidedTourModule {
}
